import IconButton from "components/atoms/button/IconButton";
import { FC, useCallback } from "react";
import { useState } from "react";
import InputsFolder from "components/molecules/inputs-folder/InputsFolder";
import { useTranslation } from "react-i18next";
import Form from "components/atoms/form/Form";
import TextArea from "components/atoms/text-area/TextArea";
import QualitySlider from "components/molecules/quality-slider/QualitySlider";
import QualityButton from "components/atoms/button/QualityButton";
import FileDropZone from "components/molecules/file-dropzone/FileDropZone";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useStoreQuality } from "lib/hooks/mutations/Customers/useStoreQuality";
import { usePermissions } from "lib/hooks/shared/usePermissions";
import withModal from "lib/helpers/hoc/withModal";
import Input from "components/atoms/input/Input";
import { useChangeQualityStatus } from "lib/hooks/mutations/Customers/useChangeQualityStatus";
import EmptyEntity from "components/atoms/empty-entity/EmptyEntity";
import { customStyles } from "lib/helpers/configs/customStyles";
import CreatableSelect from "react-select/creatable";
import Checkbox from "components/atoms/checkbox/Checkbox";
export interface IUpdateQualityCheckProps {
    customer_data: any;
    onConfirm: () => void;
    questions: any
}

const UpdateQualityCheck: FC<IUpdateQualityCheckProps> = ({ customer_data, onConfirm, questions }) => {
    const { t } = useTranslation();

    const DefaulValues = useCallback((question_type: string) => {

        if (question_type === "yes_no") {
            return 'Yes'
        }

        if (question_type === 'rating_scale') {
            return 0
        }

        return '';

    }, [])

    const {
        control,
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        defaultValues: {
            question_data: questions?.map((question: any) => ({
                question: question.question_text,
                answer: DefaulValues(question.response_type),
                options: question?.response_options ? question?.response_options.map((option: string) => {
                    return {
                        value: option,
                        label: t(option),
                    };
                }) : [],
                required: question.is_required,
                answer_type: question.response_type,
            })),
            comment: "",
            audio_one: null,
        },
    });
    console.log(control);
    
    const {
        fields,
    } = useFieldArray<any>({
        control,
        name: "question_data",
    });




    const { mutateAsync, isLoading } = useStoreQuality();
    const hasPermissionToFeedbackQuality = usePermissions([
        "manage_customers_quality_feedback",
    ]);

    const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const openConfirmationModal = (status: string) => {
        setSelectedStatus(status);
        setShowConfirmModal(true);
    };


    const SubmitForm = (data: any) => {
        const cleanedQuestionData = data.question_data?.map((q: any) => ({
        question: q.question,
        answer: q.answer,
        answer_type: q.answer_type,
    }));

    const dataWithCustomerId = {
        ...data,
        question_data: cleanedQuestionData,
        costumer_id: customer_data.id,
    };



        const formData = new FormData();

         for (let key in dataWithCustomerId) {
            const value = dataWithCustomerId[key];

            if (key === "audio_one") {
                formData.append(key, value[0]); 
            } else if (typeof value === 'object' && value !== null) {
                formData.append(key, JSON.stringify(value)); 
            } else {
                formData.append(key, value);
            }
        }
        mutateAsync(formData).then(() => {
            onConfirm()
        });
    };

    const { mutateAsync: changeStatus, isLoading: isLoadingChangeStatus } = useChangeQualityStatus()


    const confirmStatusChange = () => {
        if (!selectedStatus) return;

        changeStatus({
            costumer_id: customer_data.id,
            status: selectedStatus,
        }).then(() => {
            onConfirm();
            setShowConfirmModal(false);
            setSelectedStatus(null);
        });
    };

    return (
        <Form
            className="flex flex-col gap-5 mb-0"
            onSubmit={handleSubmit(SubmitForm)}
        >
            <div className="flex items-center gap-4 mt-5">
                <IconButton type="button" className="!bg-[#efbe12] !text-[#fff] flex-1 !py-2" onClick={() => openConfirmationModal("pending")}>
                    {t('Pending')}
                </IconButton>
                <IconButton type="button" className="bg-[#cc7272] text-[#fff] flex-1 !py-2" onClick={() => openConfirmationModal("not_reached")}>
                    {t('Not Reached')}
                </IconButton>
                <IconButton type="button" className="bg-[#70dde4] text-[#fff] flex-1 !py-2" onClick={() => openConfirmationModal("not_reachable")}>
                    {t('Not Reachable')}
                </IconButton>
            </div>
            {showConfirmModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center ">
                    <div className="absolute inset-0 bg-[--theme] opacity-[0.16] z-10"></div>
                    <div className="bg-white rounded-xl p-6 w-[90%] max-w-md shadow-xl relative z-50">
                        <h3 className="text-lg font-semibold mb-4">{t('Confirm Action')}</h3>
                        <p className="mb-6">{t('Are you sure you want to change the status')}?</p>
                        <div className="flex justify-end gap-4">
                            <IconButton
                                onClick={() => setShowConfirmModal(false)}
                                secondary={true}
                                type="button"
                                className="w-full max-w-[150px]"
                            >
                                {t('Back')}
                            </IconButton>
                            <IconButton
                                onClick={confirmStatusChange}
                                type="submit"
                                className="w-full max-w-[150px]"
                            >
                                {t('Confirm')}
                            </IconButton>
                        </div>
                    </div>
                </div>
            )}
            <InputsFolder title={t("Customer information")}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <Input
                        label="Name"
                        type="text"
                        className="w-full"
                        value={customer_data.first_name + " " + customer_data.last_name}
                        disabled
                    />
                    <Input
                        label="Phone Number"
                        type="text"
                        className="w-full"
                        value={customer_data.phone}
                        disabled
                    />
                    <Input
                        label="Postal Code"
                        type="text"
                        className="w-full"
                        value={customer_data.postal_code}
                        disabled
                    />
                    <Input
                        label="City"
                        type="text"
                        className="w-full"
                        value={customer_data.city}
                        disabled
                    />
                </div>
            </InputsFolder>
            {customer_data.familyMembersQuality.length > 0 ? (
                <InputsFolder title={t("Family members")}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        {customer_data.familyMembersQuality.map((member: any) => (
                            <Input
                                key={member.id}

                                type="text"
                                className="w-full"
                                value={member.first_name + " " + member.last_name}
                                disabled
                            />
                        ))}
                    </div>
                </InputsFolder>
            ) : null}
            <InputsFolder title={t("Quality check")}>
                <div className="flex flex-col gap-10">
                    {questions?.length !== 0 ? (
                        fields.map((question: any, index: number) => (
                            <div key={index}>
                                <div className="flex items-center mb-2 gap-3">
                                    <div className="text-primaryTextColor font-inter-medium flex-1">
                                        • {question.question}
                                    </div>
                                </div>
                                {{
                                    'yes_no': (
                                        <div className="flex items-center gap-2">
                                            <Controller
                                                name={`question_data[${index}].answer` as any}
                                                control={control}
                                                render={({ field }) => (
                                                    <QualityButton
                                                        isChecked={field.value === "Yes"}
                                                        onChange={() => field.onChange("Yes")}
                                                        name={"checkbox_" + index}
                                                    >
                                                        {t('Yes')}
                                                    </QualityButton>
                                                )}
                                            />
                                            <Controller
                                                name={`question_data[${index}].answer` as any}
                                                control={control}
                                                render={({ field }) => (
                                                    <QualityButton
                                                        isChecked={field.value === "No"}
                                                        onChange={() => field.onChange("No")}
                                                        isNegative
                                                        name={"checkbox_" + index}

                                                    >
                                                        {t('No')}
                                                    </QualityButton>
                                                )}
                                            />
                                        </div>
                                    ),
                                    'short_text': (
                                        <Input
                                            type="text"
                                            placeholder={t('Write your answer here...')}
                                            {...register(`question_data.${index}.answer`, { required: question.required ? t("This field is required") : false })}
                                            error={errors?.question_data ? (errors as any)?.question_data[index]?.answer : null}
                                        />
                                    ),
                                    'long_text': (
                                        <TextArea
                                            rows={4}
                                            placeholder={t('Write your answer here...')}
                                            {...register(`question_data.${index}.answer`, { required: question.required ? t("This field is required") : false })}
                                            error={errors?.question_data ? (errors as any)?.question_data[index]?.answer : null}

                                        />
                                    ),
                                    'rating_scale': (
                                        <div className="pb-7">
                                            <Controller
                                                name={`question_data.${index}.answer`}

                                                control={control}
                                                render={({ field }) => (
                                                    <QualitySlider
                                                        value={field?.value || 0}
                                                        onChange={field.onChange}
                                                    />
                                                )}
                                            />
                                        </div>
                                    ),
                                    'dropdown_selection': (
                                        <div className="relative">

                                            <Controller
                                                control={control}
                                                name={`question_data.${index}.answer`}
                                                rules={{ required: question.required ? t("This field is required") : false }}
                                                render={({ field }) => (
                                                    <CreatableSelect<any, false>
                                                        {...field}
                                                        placeholder={t('Choose Question Type')}
                                                        options={question.options}
                                                        value={
                                                            field.value
                                                                ? { value: field.value, label: field.value }
                                                                : null
                                                        }
                                                        className="cursor-pointer !w-full font-inter-regular react-select-container"
                                                        classNamePrefix="react-select !w-full"
                                                        onChange={(newValue: any, actionMeta: any) => {
                                                            if (actionMeta.action === "select-option" && newValue?.value) {
                                                                field.onChange(newValue.value);
                                                            }
                                                        }}
                                                        styles={customStyles}
                                                        isValidNewOption={() => false}
                                                        menuPosition={"fixed"}
                                                        menuPortalTarget={document.body}
                                                    />
                                                )}

                                            />
                                            {(errors as any)?.question_data && (
                                                <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-16px]  left-[2px]">
                                                    {(errors as any)?.question_data[index]?.answer.message as any}
                                                </div>
                                            )}
                                        </div>
                                    ),
                                    'multiple_choice': (
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 relative">
                                            {question.options.map((option: any, optionIndex: number) => (
                                                <Controller
                                                    control={control}
                                                    name={`question_data.${index}.answer`}
                                                    key={optionIndex}
                                                    rules={{ required: question.required ? t("This field is required") : false }}

                                                    render={({ field }) => {
                                                        const currentValues = field.value || [];

                                                        const isChecked = currentValues.includes(option.value);

                                                        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                                            const checked = e.target.checked;

                                                            const newValue = checked
                                                                ? [...currentValues, option.value]
                                                                : currentValues.filter((val: string) => val !== option.value);

                                                            field.onChange(newValue);
                                                        };

                                                        return (
                                                            <div className="flex items-center gap-1">
                                                                <Checkbox
                                                                    value={option.value}
                                                                    checked={isChecked}
                                                                    onChange={handleChange}
                                                                />
                                                                <h1 className="capitalize text-[#282D46] text-[14px] whitespace-nowrap font-inter-regular">
                                                                    {t(option.label)}
                                                                </h1>
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            ))}
                                            {(errors as any)?.question_data && (
                                                <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-18px] 2xl:bottom-[-18px]  left-[2px]">
                                                    {(errors as any)?.question_data[index]?.answer.message as any}
                                                </div>
                                            )}
                                        </div>
                                    )
                                }[question.answer_type as string]}
                            </div>
                        ))
                    ) : (
                        <div>
                            <EmptyEntity classes={{ childrenclass: "text-center" }}>
                                {t('No quality question answers have been added for this customer')}.
                            </EmptyEntity>
                        </div>
                    )}
                </div>
            </InputsFolder>
            <InputsFolder
                title={t("Comments")}
                childrenClassName="max-h-[180px] h-full"
            >
                <div>
                    <TextArea
                        rows={4}
                        {...register("comment")}
                        className="resize-none border-[1px] border-inputborder rounded-[8px] w-full p-[7px] 2xl:p-[10px] outline-0 indent-2 placeholder-[#667085] font-inter-regular"
                        placeholder={t("Write your comment ...")}
                    />
                </div>
            </InputsFolder>
            <InputsFolder title={t("Upload Audio")} childrenClassName="">
                <Controller
                    control={control}
                    name="audio_one"
                    rules={{ required: t("File is required") }}
                    render={({ field: { onChange, value } }) => (
                        <FileDropZone
                            file={value}
                            setFile={onChange}
                            label=""
                            classes={{ label: "bg-white" }}
                            name="audio_one"
                            formats=".mp3, .wav"
                            error={errors.audio_one}
                            control={control as any}
                        />
                    )}
                />
            </InputsFolder>
            {
                hasPermissionToFeedbackQuality ? (
                    <IconButton
                        type="submit"
                        className="max-w-[138px] flex justify-end ml-auto"
                        disabled={isLoadingChangeStatus || isLoading}
                    >
                        {t("Save")}
                    </IconButton>
                ) : null
            }
        </Form >
    );
};
export default withModal(UpdateQualityCheck);
